import { Injectable }    from '@angular/core';
import { CanActivate } from '@angular/router';
import { ApiService } from './api.service';
import { Router } from '@angular/router';

/**
 * Only allow to render the component if the user is NOT logged in.
 * If already logged in, redirect to /applications.
 */
@Injectable()
export class AntiAuthGuard implements CanActivate {

  constructor(private apiService: ApiService, private router: Router) {}

  canActivate() {
    return new Promise((resolve, reject) => {
      this.apiService.isAuthenticated().then(() => {
        this.router.navigateByUrl('users');
        reject(false);
      }).catch((err) => {
        resolve(true);
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/anti-authguard.service.ts